import { render, staticRenderFns } from "./coin_header.vue?vue&type=template&id=251cc6e4&"
import script from "./coin_header.vue?vue&type=script&lang=js&"
export * from "./coin_header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailInfo: require('/src/components/detail/mobile/detail_info.vue').default})
